<template>
  <div class="absolute fill-height events-page">
    <div class="absolute fill-height pb-3 gui-flex gui-flex-rows">
      <v-toolbar
      color="blue accent-3"
      dark
      extended
      flat
      class="toolbar__fixed"
        >
      </v-toolbar>
      <v-card flat class="no__radius mr-3 ml-3 table-wrap__padding wrap-scrollbar gui-flex-fill-rest gui-flex gui-flex-rows elevation-1">
        <Loader v-if="loading" skin="light"></Loader>
        <div v-else class="gui-flex gui-flex-rows">
          <div class="custom-scrollbar">
            <v-layout row wrap class="mb-3">
              <v-flex xs12>
                <h3>Přehled přepočtů provizí</h3>
              </v-flex>
            </v-layout>
            <v-layout row wrap>
              <v-flex xs12 sm4 md3>
                <osobasearch label="Spolupracovník" v-model="spolupracovnik" class="mx-2"></osobasearch>
              </v-flex>
            </v-layout>
            <div class="table-border__radius elevation-1">
              <v-data-table
                :headers="headers"
                :items="items"
                :loading="loadingTable"
                :pagination.sync="pagination"
                :total-items="pagination.totalItems"
                :rows-per-page-items="[25, 50, 100, 200]"
              >
                <template slot="items" slot-scope="props">
                  <td>{{props.item.datum | formatDate}}</td>
                  <td>
                    <router-link :to="{ path: '/klienti/' + props.item.osoba.id }" target="_blank">
                      {{ props.item.osoba.nazev_osoby }}
                    </router-link>
                  </td>
                  <td>{{props.item.puvodni_castka | formatMoney}} Kč</td>
                  <td>{{props.item.nova_castka | formatMoney}} Kč</td>
                </template>
              </v-data-table>
            </div>
          </div>
        </div>
      </v-card>
    </div>
  </div>
</template>

<script>
import Base from '@/pages/Base'
export default {
  extends: Base,
  data () {
    return {
      loading: false,
      headers: [
        { text: 'Datum', value: 'datum' },
        { text: 'Osoba', value: 'osoba' },
        { text: 'Původní částka', value: 'puvodni_castka' },
        { text: 'Nová částka', value: 'nova_castka' }
      ],
      items: [],
      loadingTable: true,
      search: "",
      timeout: null,
      counter: 0,
      pagination: {
        descending: true,
        page: 1,
        rowsPerPage: 25,
        sortBy: "datum",
        totalItems: 0
      },
      dialogCreate: false,
      sending: false,
      dialogInit: {
        sporici_program: null,
        hlavni_cilovy_produkt_id: null,
        mena_id: null
      },
      newItem: null,
      spolupracovnik: null
    }
  },
  watch: {
  	pagination: {
  		handler: function(newValue) {
        if (!this.loadingTable)
  			   this.load();
  		},
  		deep: true
  	},
    spolupracovnik () {
      this.load();
    }
  },
  mounted: function() {
    window.MenuListener.show();
    this.load();
  },
  methods: {
    queryList: function() {
      if (this.timeout != null)
        clearTimeout(this.timeout);
      this.timeout = setTimeout(function() {
        this.pagination.page = 1;
        this.load();
      }.bind(this), 200)
    },
    load: function() {
      this.counter++;
      this.loadingTable = true;
      window.API.post("prehledy/zmena-provizi/search", {
        pagination: this.pagination,
        s: this.search,
        echo: this.counter,
        osoba: this.spolupracovnik
      }).then(function(body) {
        if (this.counter != body.echo)
          return;
        this.items.replace(body.data);
        this.pagination.sortBy = body.sort.sortBy;
        this.pagination.descending = body.sort.descending;
        this.pagination.page = body.sort.page;
        this.pagination.rowsPerPage = body.sort.rowsPerPage;
        this.pagination.totalItems = body.sort.totalItems;
        this.loading = false;
        this.loadingTable = false;
      }.bind(this)).catch(function(err) {
        console.log(err);
      }.bind(this));
    }
  },
  components: {

  }
}
</script>



// WEBPACK FOOTER //
// src/pages/Prehledy/PrehledPrepoctuProvizi.vue